import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Link from '@UI/Link';
import { IconDivan, IconMatras } from './icons';
import styles from './QuizButton.module.css';

import type { LinkProps as UILinkProps } from '@divlab/divanui';
import type { FC } from 'react';

interface QuizButtonProps extends Omit<UILinkProps, 'view'> {
  view?: 'divan' | 'matras';
  isAlwaysShow?: boolean;
  label?: string;
  to?: string;
}

const QuizButton: FC<QuizButtonProps> = (props) => {
  const { view = 'matras', isAlwaysShow, to, className, ...restProps } = props;
  const { t } = useTranslation();
  const buttonId = `quiz-${view}`;

  return (
    <Link
      {...restProps}
      className={cn(styles.main, { [styles.active]: isAlwaysShow }, className)}
      id={buttonId}
      to={to || '/promo/mattrasses'}
      view='primary'
    >
      <div className={styles.content}>
        <span className={styles.text}>{t(`ui.quiz-button.${view}`)}</span>
        {view === 'divan' ? <IconDivan /> : <IconMatras />}
      </div>
    </Link>
  );
};

export default QuizButton;
